import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './CardHeader.css';

const CardHeader = ({ children, className }) => (
  <div className={classnames('CardHeader', className)}>{children}</div>
);

CardHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

CardHeader.defaultProps = {
  className: '',
};

export default CardHeader;



// WEBPACK FOOTER //
// ../ui-components/components/Card/CardHeader.jsx